import moda_1 from "./../../assets/images/proyectos/moda/moda_1.jpg";
import moda_2 from "./../../assets/images/proyectos/moda/moda_2.jpg";
import moda_3 from "./../../assets/images/proyectos/moda/moda_3.jpg";
import moda_4 from "./../../assets/images/proyectos/moda/moda_4.jpg";
import moda_5 from "./../../assets/images/proyectos/moda/moda_5.jpg";
import moda_6 from "./../../assets/images/proyectos/moda/moda_6.jpg";
import moda_7 from "./../../assets/images/proyectos/moda/moda_7.jpg";
import moda_8 from "./../../assets/images/proyectos/moda/moda_8.jpg";
import moda_9 from "./../../assets/images/proyectos/moda/moda_9.jpg";
import moda_10 from "./../../assets/images/proyectos/moda/moda_10.jpg";
import moda_11 from "./../../assets/images/proyectos/moda/moda_11.jpg";
import moda_12 from "./../../assets/images/proyectos/moda/moda_12.jpg";
import moda_13 from "./../../assets/images/proyectos/moda/moda_13.jpg";
import moda_14 from "./../../assets/images/proyectos/moda/moda_14.jpg";
import moda_15 from "./../../assets/images/proyectos/moda/moda_15.jpg";
import moda_16 from "./../../assets/images/proyectos/moda/moda_16.jpg";
import moda_17 from "./../../assets/images/proyectos/moda/moda_17.jpg";
import moda_18 from "./../../assets/images/proyectos/moda/moda_18.jpg";
import moda_19 from "./../../assets/images/proyectos/moda/moda_19.jpg";
import moda_20 from "./../../assets/images/proyectos/moda/moda_20.jpg";
import moda_21 from "./../../assets/images/proyectos/moda/moda_21.jpg";
import moda_22 from "./../../assets/images/proyectos/moda/moda_22.jpg";
import moda_23 from "./../../assets/images/proyectos/moda/moda_23.jpg";
import moda_24 from "./../../assets/images/proyectos/moda/moda_24.jpg";
import moda_25 from "./../../assets/images/proyectos/moda/moda_25.jpg";
import moda_26 from "./../../assets/images/proyectos/moda/moda_26.jpg";
import moda_27 from "./../../assets/images/proyectos/moda/moda_27.jpg";
import moda_28 from "./../../assets/images/proyectos/moda/moda_28.jpg";
import moda_29 from "./../../assets/images/proyectos/moda/moda_29.jpg";
import moda_30 from "./../../assets/images/proyectos/moda/moda_30.jpg";
import moda_31 from "./../../assets/images/proyectos/moda/moda_31.jpg";
import moda_32 from "./../../assets/images/proyectos/moda/moda_32.jpg";
import moda_33 from "./../../assets/images/proyectos/moda/moda_33.jpg";
import moda_34 from "./../../assets/images/proyectos/moda/moda_34.jpg";
import moda_35 from "./../../assets/images/proyectos/moda/moda_35.jpg";
import moda_36 from "./../../assets/images/proyectos/moda/moda_36.jpg";
import moda_37 from "./../../assets/images/proyectos/moda/moda_37.jpg";
import moda_38 from "./../../assets/images/proyectos/moda/moda_38.jpg";
import moda_39 from "./../../assets/images/proyectos/moda/moda_39.jpg";
import moda_40 from "./../../assets/images/proyectos/moda/moda_40.jpg";
import moda_41 from "./../../assets/images/proyectos/moda/moda_41.jpg";
import moda_42 from "./../../assets/images/proyectos/moda/moda_42.jpg";
import moda_43 from "./../../assets/images/proyectos/moda/moda_43.jpg";
import moda_44 from "./../../assets/images/proyectos/moda/moda_44.jpg";
import moda_45 from "./../../assets/images/proyectos/moda/moda_45.jpg";
import moda_46 from "./../../assets/images/proyectos/moda/moda_46.jpg";
import moda_47 from "./../../assets/images/proyectos/moda/moda_47.jpg";
import moda_48 from "./../../assets/images/proyectos/moda/moda_48.jpg";
import moda_49 from "./../../assets/images/proyectos/moda/moda_49.jpg";
import moda_50 from "./../../assets/images/proyectos/moda/moda_50.jpg";
import moda_51 from "./../../assets/images/proyectos/moda/moda_51.jpg";
import moda_52 from "./../../assets/images/proyectos/moda/moda_52.jpg";
import moda_53 from "./../../assets/images/proyectos/moda/moda_53.jpg";
import moda_54 from "./../../assets/images/proyectos/moda/moda_54.jpg";
import moda_55 from "./../../assets/images/proyectos/moda/moda_55.jpg";
import moda_56 from "./../../assets/images/proyectos/moda/moda_56.jpg";
import moda_57 from "./../../assets/images/proyectos/moda/moda_57.jpg";
import moda_58 from "./../../assets/images/proyectos/moda/moda_58.jpg";
import moda_59 from "./../../assets/images/proyectos/moda/moda_59.jpg";
import moda_60 from "./../../assets/images/proyectos/moda/moda_60.jpg";
import moda_61 from "./../../assets/images/proyectos/moda/moda_61.jpg";
import moda_62 from "./../../assets/images/proyectos/moda/moda_62.jpg";
import moda_63 from "./../../assets/images/proyectos/moda/moda_63.jpg";
import moda_64 from "./../../assets/images/proyectos/moda/moda_64.jpg";
import moda_65 from "./../../assets/images/proyectos/moda/moda_65.jpg";
import moda_66 from "./../../assets/images/proyectos/moda/moda_66.jpg";
import moda_67 from "./../../assets/images/proyectos/moda/moda_67.jpg";
import moda_68 from "./../../assets/images/proyectos/moda/moda_68.jpg";
import moda_69 from "./../../assets/images/proyectos/moda/moda_69.jpg";
import moda_70 from "./../../assets/images/proyectos/moda/moda_70.jpg";
import moda_71 from "./../../assets/images/proyectos/moda/moda_71.jpg";
import moda_72 from "./../../assets/images/proyectos/moda/moda_72.jpg";
import moda_73 from "./../../assets/images/proyectos/moda/moda_73.jpg";
import moda_74 from "./../../assets/images/proyectos/moda/moda_74.jpg";
import moda_75 from "./../../assets/images/proyectos/moda/moda_75.jpg";
import moda_76 from "./../../assets/images/proyectos/moda/moda_76.jpg";
import moda_77 from "./../../assets/images/proyectos/moda/moda_77.jpg";
import moda_78 from "./../../assets/images/proyectos/moda/moda_78.jpg";
import moda_79 from "./../../assets/images/proyectos/moda/moda_79.jpg";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
        name: 'Alto Las Condes Nocturno',
        image: moda_1,
        description: [
            'Campaña de Publicidad para moda de un Mall en Santiago. La modelo había llegado ese día del calor de Sao Paulo al frio de invierno lluvioso de Santiago, y terminamos como a la 1 AM, muy mojados bajo la lluvia, y ella realmente muerta de frio.'
        ],
        children: [
            {
                name: moda_1
            },
            {
                name: moda_2
            },
        ]
    }, {
        name: 'Alto Las Condes Verano',
        image: moda_3,
        description: [
            'Catálogo de moda para el Mall Alto Las Condes. Todo casi bien, salvo que el modelo hombre, estaba con fiebre todo el día, y no quiso aplazar la sesión. Sobrevivió gracias a mucho té y analgésicos.'
        ],
        children: [
            {
                name: moda_3
            },
            {
                name: moda_4
            },
            {
                name: moda_5
            },
            {
                name: moda_6
            },
            {
                name: moda_7
            },
            {
                name: moda_8
            },
        ]
    }, {
        name: 'Americanino',
        image: moda_9,
        description: [
            'Esta sesión fue una improvisación para una licitación. Tres modelos profesionales y el hijo del Director de Arte. Buscar y experimentar que se podía hacer. La foto del sillón surgió mientras ellos descansaban.'
        ],
        children: [
            {
                name: moda_9
            },
            {
                name: moda_10
            },
            {
                name: moda_11
            },
        ]
    }, {
        name: 'Elle Invierno',
        image: moda_32,
        description: [
            'Moda para la Revista Elle Chile, en el Club Hípico de Santiago. Feo y frio día.  Todo muy pastel. Son fotos muy estáticas ya que le quedaba muy chica la ropa a la Modelo y se podía mover muy poco. Lástima'
        ],
        children: [
            {
                name: moda_32
            },
            {
                name: moda_33
            },
            {
                name: moda_34
            },
        ]
    }, {
        name: 'Johnson’s',
        image: moda_36,
        description: [
            'Catálogo de Lencería. Es muy mala idea hacer un trabajo con una cámara nueva sin haberla probado. Mi primer respaldo digital para una cámara Hasselblad, que todavía no volvía de Suecia donde hubo que adaptarla para el respaldo. Entonces se me ocurrió usar una cámara prestada que no estaba bien calibrada, y no me daba foco. Usando la vieja técnica de medir el foco con una cinta métrica, logramos el foco perfecto.'
        ],
        children: [
            {
                name: moda_36
            },
            {
                name: moda_37
            },
            {
                name: moda_38
            },
            {
                name: moda_39
            }
        ]
    }, {
        name: 'Lipton Iced tea',
        image: moda_40,
        description: [
            'Campaña de lanzamiento para Lipton Iced Tea. Un largo día entre Santiago, Algarrobo y una cancha de Golf. Muy agradecidos del Cuerpo de Bomberos de Algarrobo que nos proporcionó las gotas de agua en la playa. Gran almuerzo en el tradicional Antumalal de Curacaví con todo el equipo. '
        ],
        children: [
            {
                name: moda_40
            },
            {
                name: moda_41
            },
            {
                name: moda_42
            }
        ]
    }, {
        name: 'Luciana Dubini',
        image: moda_43,
        description: [
            'La preciosa orfebre Luciana Dubini y su colección de joyas, maquillada por Teresita Ríos y el gran peinado de Eric Gómez.'
        ],
        children: [
            {
                name: moda_43
            },
            {
                name: moda_44
            },
            {
                name: moda_45
            }
        ]
    }, {
        name: 'Prueba de Vestuario',
        image: moda_46,
        description: [
            '“Prueba de Vestuario”, fue el concepto que usamos para esta sesión de fotos de moda para la revista Paula. Filmamos también un corto de moda que se puede ver en esta página.',
            'Muy mala idea también que al momento de empezar las fotos, se me caiga la cámara y se rompa. Partir a arrendar una cámara con la modelo ya vestida, y re-comenzar con una cámara desconocida, pone mucha presión. Pero: fue un día. Gran estilismo de Alvaro Renner.'
        ],
        children: [
            {
                name: moda_46
            },
            {
                name: moda_47
            },
            {
                name: moda_48
            },
            {
                name: moda_49
            },
            {
                name: moda_50
            },
            {
                name: moda_51
            },
            {
                name: moda_52
            },
            {
                name: moda_53
            },
            {
                name: moda_54
            },
            {
                name: moda_55
            },
            {
                name: moda_56
            }

        ]
    }, {
        name: 'Thrift Shop',
        image: moda_57,
        description: [
            'Ropa usada. Mi segunda historia de moda para la revista Paula, y mi primera portada a pesar de mis 30 años de fotografía. Fotos look vintage para acompañar el tema.'
        ],
        children: [
            {
                name: moda_57
            },
            {
                name: moda_58
            },
            {
                name: moda_59
            },
            {
                name: moda_60
            },
            {
                name: moda_61
            }
        ]
    }, {
        name: 'Pool boy',
        image: moda_62,
        description: [
            'Muchas veces me pasó, siendo asistente de fotografía, y al estar en otros lugares alrededor de los modelos, (distintos al punto de la cámara) y descubrir luces interesantes. Filmamos una historia para probar unos nuevos lentes anamórficos de Cine, y  dando vueltas alrededor de la situación principal, me encontré estas dos imágenes, con muy poca luz, pero muy interesantes.'
        ],
        children: [
            {
                name: moda_62
            },
            {
                name: moda_63
            }
        ]
    }, {
        name: 'Ladrona y oso',
        image: moda_64,
        description: [
            'Es muy difícil trabajar en “blanco” imaginándose como será la ilustración que va a darle el sentido a la foto final. Anelise Rufine colgando del techo del estudio tratando de robar algo que no está ahí, y Talita Polita, llamando a un oso que no existe.'
        ],
        children: [
            {
                name: moda_64
            },
            {
                name: moda_65
            }
        ]
    }, {
        name: 'Bruna',
        image: moda_66,
        description: [
            'Muchos rulos en el pelo de Bruna para una campaña de telefonía. Foto sacada en la sala de Pool de mi estudio. Estábamos bajando hacia el Estudio cuando descubrimos que esta era la ubicación ideal y la hicimos ahí mismo.'
        ],
        children: [
            {
                name: moda_66
            }
        ]
    }, {
        name: 'Ripley Invierno',
        image: moda_67,
        description: [
            'Un desafío para ambientar este catálogo de abrigos en un ambiente de CINE.',
            'Harta búsqueda y los nervios, antes de empezar, de no saber por donde. Hasta que llega la maravillosa Liz Solari con una chaqueta de cuero burdeos y la foto se empieza a armar frente a ti. Súper entretenido además mezclar luces tan distintas: HMI, Tungsteno, Flash y tubos fluorescentes, usados para iluminar y como elementos de la decoración.'
        ],
        children: [
            {
                name: moda_67
            },
            {
                name: moda_68
            },
            {
                name: moda_69
            },
            {
                name: moda_70
            },
            {
                name: moda_71
            },
            {
                name: moda_79
            }
        ]
    }, {
        name: 'Moda SEI',
        image: moda_72,
        description: [
            'Típico: Moda de verano en invierno, y como inventar sol en el estudio. Nada que un Fresnel 20K Arri no pueda hacer, mas el trabajo de retoque de Roberto Muñoz. Algunas discrepancias con colores elegidos por cliente, me hacen mostrar estas fotos en Blanco y Negro.'
        ],
        children: [
            {
                name: moda_72
            },
            {
                name: moda_73
            },
            {
                name: moda_74
            }
        ]
    }, {
        name: 'Tanner',
        image: moda_75,
        description: [
            'Una pequeña fantasía para una Empresa Financiera. Fue uno de mis primeros retoques, antes que se profesionalizara el tema. Muchas horas de noche para lograr el efecto, con computadores muy básicos en ese momento.'
        ],
        children: [
            {
                name: moda_75
            }
        ]
    }, {
        name: 'Polaroid',
        image: moda_76,
        description: [
            'El último rollo de diapositiva Polaroid instantánea que me quedaba para una foto con las nuevas modelos de la recientemente inaugurada Agencia de Modelos Elite en Santiago. Me da tanta pena que ya no existan tantas películas que hacían tanto por la creatividad. Distintas diapositivas y negativos … Una pena.'
        ],
        children: [
            {
                name: moda_76
            }
        ]
    }, {
        name: 'Jose Luis',
        image: moda_77,
        description: [
            'No puedo dejar fuera de esta página, dos fotos realizadas en París con el gran y único maquillador Chileno Don José Luis Armijo.',
            'Estrella del mundo del Maquillaje en Europa, y con la generosidad de usar su tiempo libre para ayudar y enseñar a este fotógrafo a iniciar su carrera.',
            'Un muy importante fotógrafo de moda, me confesó que no podía creer que José Luis no haya querido trabajar con el e hiciera Tests conmigo. Un gran honor.',
            'Otra película que echo de menos: Kodak E200.'
        ],
        children: [
            {
                name: moda_77
            },
            {
                name: moda_78
            }
        ]
    }, {
        name: 'Tonka',
        image: moda_12,
        description: [
            'Este trabajo fue para una Empresa extranjera de belleza filmada en Chile. La Gran Tonka Tomicic hizo un gran trabajo y demostró toda su fuerza y dedicación. Primer día estuvo todo el día metida en una tina de baño. El segundo día trabajó con niños y en la noche filmando en un exterior, una noche de mucho frio y ella con un vestidito de verano. Al tercer día eran las fotos y por supuesto llegó con un resfrío enorme. Propuse posponer, pero ella, nada. Vamos para adelante. Preciosa y trabajadora.'
        ],
        children: [
            {
                name: moda_12
            }
        ]
    }, {
        name: 'Soft',
        image: moda_13,
        description: [
            'Test, test y test. Siempre buscando alguna pequeña cosa que puede darme algo especial. Para estas fotos construí una enorme caja de luz de 6 metros de largo.'
        ],
        children: [
            {
                name: moda_13
            },
            {
                name: moda_14
            }
        ]
    }, {
        name: 'Bernardita',
        image: moda_15,
        description: [
            'La adorable Bernardita que me ayudó a, nuevamente, a probar luces. Esta vez una cajita de luz chiquitita que inventamos.'
        ],
        children: [
            {
                name: moda_15
            },
            {
                name: moda_16
            }
        ]
    }, {
        name: 'White skin',
        image: moda_17,
        description: [
            'Durante una filmación de Belleza hice estas fotos para ir visualizando los resultados. Esta luz la había hecho con Flash, pero no con luz continua. Los brillos de espejos son preciosos. Un placer trabajar con Deborah y con Vanessa'
        ],
        children: [
            {
                name: moda_17
            },
            {
                name: moda_18
            },
            {
                name: moda_19
            }
        ]
    }, {
        name: 'Garage Light',
        image: moda_20,
        description: [
            'Nuevamente fotos durante una filmación, tratando de entender los comportamientos de los diferentes sensores. Usando la luz del portón del estudio.'
        ],
        children: [
            {
                name: moda_20
            },
            {
                name: moda_21
            },
            {
                name: moda_22
            },
            {
                name: moda_23
            }
        ]
    }, {
        name: 'Chocolate filter',
        image: moda_24,
        description: [
            'Beauty, filmada y fotografiada. Tratando de tener consistencia entre la película y las fotos.'
        ],
        children: [
            {
                name: moda_24
            },
            {
                name: moda_25
            }
        ]
    }, {
        name: 'Dayane',
        image: moda_26,
        description: [
            'La Bella Dayane Melo recién llegada a Chile.'
        ],
        children: [
            {
                name: moda_26
            },
            {
                name: moda_27
            }
        ]
    }, {
        name: 'Fresnel light',
        image: moda_29,
        description: [
            'Distintos looks iluminados con HMI o con Tungsteno para  lograr luces suaves e imágenes bellas. Cual es cual? '
        ],
        children: [
            {
                name: moda_29
            },
            {
                name: moda_30
            },
            {
                name: moda_31
            }
        ]
    }, {
        name: 'Elite beauty',
        image: moda_28,
        description: [
            'Para Elite Chile una foto de belleza de sus talentos.'
        ],
        children: [
            {
                name: moda_28
            }
        ]
    }
]